import axios from "axios";
import jwtDecode from "jwt-decode";
import store from "./store";
import utils from "./utils";
import Qs from "qs";

axios.defaults.headers.post["Content-Type"] = "application/x-www-form-urlencoded";
axios.defaults.timeout = 2 * 60 * 1000;
// 请求拦截器
axios.interceptors.request.use(
  function(config) {
    if (store.getters.token) {
      // 判断是否存在token，如果存在的话，则每个http header都加上token
      config.headers.Authorization = `Bearer ${store.getters.token}`;
      refreshToken();
    }
    return config;
  },
  function(error) {
    return Promise.reject(error);
  }
);
// 响应拦截器
axios.interceptors.response.use(
  function(response) {
    return response;
  },
  function(error) {
    if (error.response) {
      switch (error.response.status) {
        case 401:
          utils.goErr(cfg.errs.NoAuthority);
      }
    }
    return Promise.reject(error);
  }
);
let tokenIsRefreshing = false;
function refreshToken() {
  // 刷新条件：距离上次刷新超过10分钟
  if (cfg.token) {
    // 假token时不需要刷新
    return;
  }
  if (!store.getters.token) {
    return; // 尚未登录
  }
  if (tokenIsRefreshing) {
    return; // 正在刷新
  }
  if (!store.state.tokenExp) {
    const tokenObj = jwtDecode(store.getters.token);
    store.state.tokenExp = tokenObj.exp + "000";
  }
  if (new Date() > new Date(Number(store.state.tokenExp))) {
    utils.goErr(cfg.errs.OverdueToken);
    return; // 已经过期了
  }
  if (store.state.lastRefreshTime && new Date() < new Date(Number(store.state.lastRefreshTime + 1000 * 60 * 10))) {
    return; // 刚刷新过，还不到10分钟，不需要再刷新
  }

  tokenIsRefreshing = true;
  api
    .refresh(store.getters.refToken)
    .then((res) => {
      utils.saveToken(res);
    })
    .catch((err) => {
      console.log(err);
    })
    .finally(() => {
      // tokenIsRefreshing = false
    });
}

// 封装axios的post请求
export function post(url, para) {
  return new Promise((resolve, reject) => {
    axios
      .post(url, para)
      .then((response) => {
        if (response.data.code === 0) {
          resolve(response.data.context);
        } else {
          reject(response.data);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
}
// Axios post JSON request
export function postJson(url, para) {
  return new Promise((resolve, reject) => {
    axios
      .post(url, para, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.data.code === 0) {
          resolve(response.data.context);
        } else {
          reject(response.data);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
}
// 封装axios的get请求
export function get(url, para) {
  return new Promise((resolve, reject) => {
    if (para && para.pageIndexOnView !== undefined) {
      para.pageIndex = para.pageIndexOnView - 1;
    }
    axios
      .get(url, {
        params: para,
        paramsSerializer: (params) => {
          return Qs.stringify(params, { indices: false });
        },
      })
      .then((response) => {
        if (response.data && response.data.code === 0) {
          resolve(response.data.context);
        } else {
          console.log(response);
          reject(response.data);
        }
      })
      .catch((error) => {
        reject(error);
      })
      .finally(() => {});
  });
}
// 封装axios的put请求
export function put(url, para) {
  return new Promise((resolve, reject) => {
    axios
      .put(url, para)
      .then((response) => {
        if (response.data.code === 0) {
          resolve(response.data.context);
        } else {
          reject(response.data);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
}
// 封装axios的delete请求
export function del(url, para) {
  return new Promise((resolve, reject) => {
    axios
      .delete(url, para)
      .then((response) => {
        if (response.data.code === 0) {
          resolve(response.data.context);
        } else {
          reject(response.data);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
}

function headerFn(para) {
  const { cardInfo, ipMac } = store.state;
  if (!para) {
    return ipMac || {};
  }
  if (para.data && para.data.psn_no && cardInfo.header && cardInfo.psn_no === para.data.psn_no) {
    // 如果是刷卡并且刷卡里的人员和参数中的人员编号一致
    return cardInfo.header;
  }
  return ipMac || {};
}

const api = {
  // 登录
  login(para) {
    return post("/api/login", para);
  },
  // 刷新token
  refresh(refToken) {
    return get(`/api/refresh?token=${refToken}`);
  },
  getToken(code, uri) {
    return get(`/api/token?code=${code}&uri=${uri}`);
  },
  getPermission() {
    return get("/api/login/permission");
  },
  // 取得动态配置
  getSetting(para) {
    return get("/api/md/setting", para);
  },
  // 取得当前服务器日期时间
  getServerTime() {
    return get("/api/common/currentDateTime");
  },
  // 保存动态配置
  saveSetting(para) {
    if (para.id) {
      return put("/api/md/setting/" + para.id, para);
    } else {
      return post("/api/md/setting", para);
    }
  },
  /** ****************** 用户 ****************** **/
  getCurrentUser() {
    return get("/api/login/currentUser", {});
  },
  //主数据用户
  queryStaff: (para) => {
    return get("/api/md/staff", para);
  },
  getStaff: (id) => {
    return get(`/api/md/staff/${id}`);
  },
  // saveUser(para) {
  //   if (para.id) {
  //     return put('/api/user/info/' + para.id, para)
  //   } else {
  //     return post('/api/user/info', para)
  //   }
  // },
  // =================== 字典 ====================
  queryDict(type, para) {
    const parts = type.split("-");
    if (parts.length > 1) {
      const svc = parts[0].replace(parts[0][0], parts[0][0].toLowerCase());
      type = parts[1];
      return get(`/api/${svc}/dict/${type}`, para);
    } else {
      return get(`/api/dict/${type}`, para);
    }
  },
  //
  queryMedDict(type) {
    return get(`/api/med/dict/type/${type}`);
  },
  // saveDict(para) {
  //   const parts = para.type.split('-')
  //   if (parts.length > 1) {
  //     const svc = parts[0].replace(parts[0][0], parts[0][0].toLowerCase())
  //     const type = parts[1]
  //     if (para.id) {
  //       return put(`/api/${svc}/dict/${para.id}`, para)
  //     } else {
  //       return post(`/api/${svc}/dict/${type}`, para)
  //     }
  //   } else {
  //     if (para.id) {
  //       return put(`/api/dict/${para.id}`, para)
  //     } else {
  //       return post(`/api/dict/${para.type}`, para)
  //     }
  //   }
  // },
  // deleteDict(id) {
  //   return del(`/api/dict/${id}`)
  // },
  // =================== 部门 ====================
  queryDept(para) {
    return get("/api/md/dept", para);
  },
  // =================== 患者 ====================
  // 根据身份证信息获取用户，没有则会自动新建
  getOrCreatePatientByIdInfo: (para) => {
    return post(`/api/md/patient/idInfo`, para);
  },
  // 根据医保卡号获取用户，先去医保接口获取身份证信息，再去检索用户，没有则会自动新建
  getOrCreatePatientByInsurance: (insuranceNo) => {
    return get(`/api/md/patient/insuranceNo/${insuranceNo}`);
  },
  // 门诊就诊号、姓名、电话查询
  getPatientByKeyword: (payload) => {
    return get(`/api/md/patient`, payload);
  },
  // 通过id获取患者信息
  getPatientById: (id) => {
    return get(`/api/md/patient/${id}`);
  },
  // 根据证件号码查找用户，不一定是身份证号
  getPatientByIdNo: (idNo, idType) => get("/api/md/patient/card", { no: idNo, type: idType }),
  // 保存患者信息
  savePatient: (para) => {
    if (para.id) {
      return put(`/api/md/patient/${para.id}`, para)
    } else {
      return post('/api/md/patient', para)
    }
  },
  // =================== 门诊挂号 ====================
  // 号别（就诊号类别）
  queryRegType(para) {
    return get("/api/op/regType", para);
  },
  // 出诊时段
  queryPeriodList(date, period) {
    return get(`api/op/regStatistic/periodList`, { date: date, periodType: period });
  },
  // 挂号对象
  queryTarget: (para) => {
    return get("/api/op/regTarget", para);
  },
  // 渠道
  queryChannel(para) {
    return get("/api/op/regChannel", para);
  },
  // 获取支付记录
  getPayment(id) {
    return get(`/api/fee/opPayment/${id}`);
  },
  // 就诊号号池信息
  queryReg(para) {
    return get(`/api/op/reg`, para);
  },
  // 处方信息
  queryRp(para) {
    return get(`/api/op/rp`, para);
  },
  //获取收费员当前发票号
  invoiceCurrent: () => {
    return get("/api/op/regInvoice/current");
  },
  // =================== 频率 ====================
  queryFrequency: (para) => {
    return get(`/api/md/frequency`, para);
  },
  // =================== 菜单栏 ====================
  getMyMenus: (para) => {
    return post(`/api/md/menus/meMenus`, para);
  },
  // print template
  getPrintTemplate(para) {
    return get("/api/md/printTemplate", para);
  },
  // 查询企业
  getEnterpriseByPat: (id) => get(`/api/md/enterprise/${id}/pat`),
  // 查询患者是否可使用企业支付
  getUsableByPat: (id, para) => get(`/api/md/enterprise/${id}/usable`, para),
  // 医保目录列表
  getMedCatalog: (tradeCode, params) => get(`/api/med/catalog/${tradeCode}`, params),
  // 医保交易
  exec: (tradeCode, para, header) => {
    return post(`/api/med/trade/${store.state.medCode}/${tradeCode}`, { header: header || headerFn(para), input: para });
  },
  // 医保设置列表
  getMedicalInsurance: (params) => get('/api/med/hospital', params)
};
export default api;
